import React, {CSSProperties, PropsWithChildren, useCallback, useRef} from "react";
import './modal.scss';
import windowClose from "../../assets/window-close.svg";
import {useTheme} from "../../context/themeContext";
import classNames from "classnames";


export interface ModalProps {
  title: string;
  setVisible: (close: boolean) => void;
  testId?: string;
  style?: CSSProperties;
  narrow?: boolean;
}


const Modal = ({title, setVisible, testId, children, style, narrow}: PropsWithChildren<ModalProps>) => {
  const ref = useRef<any>(null);
  const {theme} = useTheme();

    const className = classNames(
        'modal',
        narrow && 'narrow'
    )

  const handleCloseClick = (e) => {
    setVisible(false);
  }

  return (
    <div
        className={className}
        {...(testId ? {'data-testid': testId} : {})}
    >
      <div
        className={`modal-wrapper ${theme}`} ref={ref}
        style={style}
      >
        <div className="modal-content">
          <div className={`content-header ${theme}`}>
            <span>{title}</span>
            <img onClick={handleCloseClick} src={windowClose} alt="close"/>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal;